var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"relative w-full"},[_c('WaitElem')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }